import { gql } from '@apollo/client';

export const USER = gql`
  query user($id: ID!) {
    client {
      user(id: $id) {
        id
        name
        email
        roles {
          id
          roleCode
        }
        employee {
          staffCode
          firstName
          lastName
        }
      }
    }
  }
`;

export interface UserQueryVariables {
  id: string;
}

export interface UserQueryResult {
  client: {
    user: User | null;
  };
}

export interface User {
  id: string;
  name: string;
  email: string;
  roles: Role[];
  employee: Employee | null;
}

export interface Employee {
  staffCode: string;
  firstName: string;
  lastName: string;
}

export interface Role {
  id: string;
  roleCode: RoleCode;
}

export type RoleCode =
  | 'stress_check_practitioner'
  | 'stress_check_person_in_charge'
  | 'regular_health_checkup_user'
  | 'user_manager';

export const LMS_USER_ROLE = gql`
  query lmsUserRole($identifier: String!) {
    lmsUser(identifier: $identifier) {
      email
      clientRole
    }
  }
`;

export interface LmsUserRoleQueryVariables {
  identifier: string;
}

export interface LmsUserRoleQueryResult {
  lmsUser: LmsUser;
}

export interface LmsUser {
  email: string;
  clientRole: string;
}

export const CHANGE_ROLE = gql`
  mutation changeRole($input: ChangeRoleInput!) {
    changeRole(input: $input) {
      client {
        id
      }
    }
  }
`;

export interface ChangeRoleQueryVariables {
  input: {
    userRoleChanges: UserRoleChange[];
  };
}

interface UserRoleChange {
  id: string;
  roleCodes: string[];
  delete: boolean;
}
